import React from 'react';
import { TimePicker } from 'antd';
import dayjs from 'dayjs';
import type { WidgetProps } from '../registry';

export const SimpleTimeWidget: React.FC<WidgetProps> = ({
  widget,
  onChange,
  onBlur,
  error,
  warning,
}) => {
  const value = widget.value ? dayjs(widget.value, 'HH:mm:ss') : null;

  return (
    <div className="rul-widget-field">
      {widget.label && (
        <label className="rul-widget-field-label">
          {widget.label}
          {widget.required && <span className="required">*</span>}
        </label>
      )}
      <TimePicker
        value={value}
        placeholder={widget.placeholder}
        disabled={widget.disabled}
        status={error ? 'error' : warning ? 'warning' : ''}
        format={widget.format || 'HH:mm:ss'}
        style={{ width: '100%' }}
        size="large"
        onChange={(time) => {
          const formattedValue = time ? time.format('HH:mm:ss') : null;
          onChange?.(widget.name, formattedValue);
          // TimePicker triggers blur on selection, so also call onBlur
          onBlur?.(widget.name, formattedValue);
        }}
      />
      {error && <div className="rul-widget-error">{error}</div>}
      {warning && !error && <div className="rul-widget-warning">{warning}</div>}
    </div>
  );
};
